import React, { useRef, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Form } from 'react-final-form';

import { isCountryFR } from '@front/common/src/utils/country';

import { translate } from '@front/i18n';

import Button from '@front/web-ui/src/components/button/button';
import Text from '@front/web-ui/src/components/base-text/variants/text';

import { Screen } from '../../components/screen/screen';
import DisponibilitySlider from '../../components/disponibility-label/disponibility-slider';
import ButtonBar from '../../components/button-bar/button-bar';
import { route } from '../../routes/routes';
import { useStepper } from '../../routes/use-stepper';
import { useNavigateHistoryWithQuery } from '../../hooks/use-navigate-history-with-query';
import { useRevenueSimulatorInformation } from '../../contexts/signup-form-context';
import { logSignupStepEvent } from '../../utils/tracking';

import SimulationCard from './simulation-card';

const t = translate('screens.revenue_simulator');

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledDiv = styled.div`
  margin-top: 20px;

  & > :not(:first-child) {
    margin-top: 10px;
  }
`;

const RevenueSimulator = () => {
  const { revenueSimulator, setRevenueSimulator } = useRevenueSimulatorInformation();
  const { historyPushWithQuery } = useNavigateHistoryWithQuery();
  const { nextRoute, currentStep } = useStepper();
  const sliderRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    logSignupStepEvent({ step: currentStep, universe: 'cleaning' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = useCallback(
    // @ts-ignore TODO: set typing
    (values) => {
      setRevenueSimulator(values);
      historyPushWithQuery(route(nextRoute));
    },
    [historyPushWithQuery, nextRoute, setRevenueSimulator],
  );

  return (
    <Screen title={t('.title')}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ hours_simulator: 1 }}
        mutators={{
          setValue: (args, state, utils) => {
            utils.changeValue(state, 'hours_simulator', () => args[1]);
          },
        }}
      >
        {({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <DisponibilitySlider
              id='hours_simulator'
              name='hours_simulator'
              min={1}
              max={40}
              hours={values.hours_simulator}
              ref={sliderRef}
              initialValue={revenueSimulator?.hours_simulator ? +revenueSimulator.hours_simulator : 25}
            />
            <SimulationCard
              title={t('.simulator_card.title')}
              hours={values.hours_simulator || 1}
              isDisabled={!values.hours_simulator}
            />
            {values.hours_simulator !== 0 && (
              <StyledDiv>
                <Text>{t('.benefits_1')}</Text>
                <Text>{t('.benefits_2')}</Text>
                {isCountryFR() && <Text>{t('.benefits_3')}</Text>}
              </StyledDiv>
            )}
            <ButtonBar>
              <StyledButton size='lg' type='submit'>
                {t('.cta_text')}
              </StyledButton>
            </ButtonBar>
          </form>
        )}
      </Form>
    </Screen>
  );
};

export default RevenueSimulator;
